import Breadcrumb from "components/Breadcrumb/Breadcrumb";
import Tabs from "components/TabNavBar/Tab";
import TaxInvoiceAllXML from "pages/TaxInvoiceItem/TaxInvoiceAllXML";
import React, { useEffect, useState } from "react";
import CustomerWiseSale from "./CustomerWiseSale";
import DashBoardCategoryWiseSalesReport from "./DashBoardCategoryWiseSalesReport";
import DashboardRevenueReport from "./DashboardRevenueReport";
import FinancialYearSalesReport from "./FinancialYearSalesReport";
import ItemRevenueReportTest from "./ItemRevenueReportTest";
import TaxInvoiceSalesReport from "./TaxInvoiceSalesReport";

const tabItems = [
  { label: "Sales Report", value: "revenuereport" },
  { label: "Item-Wise Sales", value: "itemwiserevenuereport" },
  { label: "Category-Wise Sales", value: "categoryWiseReport" },
  { label: "Sales-Register", value: "taxInvoiceSalesReport" },
  { label: "Customer-Wise Sales", value: "customerwisesale" },
  { label: "FY-Summary", value: "financialyearsales" },
  { label: "XML Download", value: "XMLAll" },
];
const tabTitles = {
  revenuereport: "Reports & Analysis > Sales Report",
  itemwiserevenuereport: "Reports & Analysis > Item-wise Sales Report",
  categoryWiseReport: "Reports & Analysis > Category-Wise Sales Report",
  taxInvoiceSalesReport: "Reports & Analysis > Sales-Register Sales Report",
  customerwisesale: "Reports & Analysis > Customer-Wise Sales Report",
  financialyearsales: "Reports & Analysis > Financial-Year Sales Report",
  XMLAll: "Reports & Analysis > XML Downloads",
};
const DashBoardTestAll = React.memo(function DashBoardTestAll(props) {
  const childRef = React.useRef(null);
  const [download, setDownload] = useState(false);
  const [activeTab, setActiveTab] = useState("Supplier PO"); // Default tab

  useEffect(() => {
    const storedTab = sessionStorage.getItem("tab");
    if (storedTab) {
      setActiveTab(storedTab);
    } else {
      setActiveTab("revenuereport"); // Set default tab if none is found
    }
  }, []);
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sessionStorage.setItem("tab", tab);
  };

  function downloadExcel() {
    childRef.current.downloadExcel();
  }
  function downloadPdf() {
    childRef.current.downloadPdf();
  }

  const breadcrumbItems = tabTitles[activeTab]
    ? tabTitles[activeTab].split(">").map((label, index, arr) => ({
        label: label.trim(),
        path: index < arr.length - 1 ? "/dashboardtestall" : null, // Add real paths here if needed
      }))
    : [];

  return (
    <>
      <div className="w-full flex  flex-col">
        <div className="flex flex-row justify-between w-full mt-3 ">
          <div className="flex justify-start items-start w-full">
            <Breadcrumb items={breadcrumbItems} />
          </div>
          {(activeTab === "itemwiserevenuereport" ||
            activeTab === "taxInvoiceSalesReport") && (
            <div className="flex text-3xl  flex-row justify-end items-center font-inter px-[10px] w-full leading-none tracking-tight text-gray-900 md:text-4xl lg:text-5xl dark:text-white">
              <div
                className="flex flex-col relative z-20"
                onMouseEnter={() => setDownload(!download)}
                onMouseLeave={() => setDownload(!download)}
              >
                <span
                  id="dropdownDefaultButton"
                  data-dropdown-toggle="dropdown"
                  className="text-white-A700 bg-blue-400 hover:bg-blue-400 font-medium rounded-lg text-xs px-3 py-1 text-center inline-flex items-center dark:bg-blue-400 dark:hover:bg-blue-400 dark:focus:ring-blue-400"
                  type="button"
                >
                  {" All Records Download"} &nbsp;{" "}
                  <svg
                    class="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </span>
                <div
                  className={`${
                    download ? "absolute top-[24px]" : "hidden"
                  } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-full bg-white-A700  dark:bg-gray-700`}
                >
                  <ul
                    class="py-0 text-sm text-gray-700 dark:text-gray-200"
                    aria-labelledby="dropdownDefaultButton"
                  >
                    <li>
                      <span
                        className="block  py-1 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white text-center rounded-lg text-sm font-medium text-gray-700 dark:text-gray-200"
                        onClick={downloadExcel}
                      >
                        Excel
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>

        <Tabs
          tabs={tabItems}
          activeTab={activeTab}
          onTabChange={handleTabClick}
        />
        <div className="w-full border rounded-md">
          {activeTab === "revenuereport" && (
            <DashboardRevenueReport ref={childRef} />
          )}
          {/* {activeTab === "itemwiserevenuereport" && (
            <DashbordItemWiseRevenueReport ref={childRef} />
          )}  */}
          {activeTab === "itemwiserevenuereport" && (
            <ItemRevenueReportTest ref={childRef} />
          )}
          {activeTab === "categoryWiseReport" && (
            <DashBoardCategoryWiseSalesReport ref={childRef} />
          )}
          {activeTab === "taxInvoiceSalesReport" && (
            <TaxInvoiceSalesReport ref={childRef} />
          )}
          {activeTab === "customerwisesale" && (
            <CustomerWiseSale ref={childRef} />
          )}
          {activeTab === "financialyearsales" && (
            <FinancialYearSalesReport ref={childRef} />
          )}
          {activeTab === "XMLAll" && <TaxInvoiceAllXML ref={childRef} />}
        </div>
      </div>
    </>
  );
});
export default DashBoardTestAll;
